/* eslint-disable */
import sysConfig from '@/configs/sys';
import validator from '@/lib/json-validator';

const matlsApiUrl = sysConfig.matlsApiUrl;

validator
  .addSchema('/user/putstudents4app', {
    type: 'object',
    properties: {
      userid: {type: 'string'},
      fullname: {type: 'string'},
      schoolid: {type: 'string'},
      gender: {type: 'string', 'pattern': '^(男性|女性)$'},
      grade: {type: 'number'},
      pcellphone: {type: 'string'}
    },
    required: ['userid']
  });


export default {
  validateEmail(email) {
    email = encodeURIComponent(email);
    return fetch
      .get(`${matlsApiUrl}/users/alreadyUser/${email}`)
      .then(res => res.json());
  },

  signup(userJson) {
    return fetch
      .post(`${matlsApiUrl}/users/poststudents4app`, {params: userJson})
      .then(res => res.json());
  },

  resetPassword(email) {
    return fetch
      .post(`${matlsApiUrl}/requestresetpwd`, {params: {email}})
      .then(res => res.json());
  },

  getProfileByID(userid) {
    return fetch
      .get(`${matlsApiUrl}/users/${userid}`)
      .then(res => res.json());
  },

  getProfileByUsername(username) {
    return fetch
      .get(`${matlsApiUrl}/users?username=${username}`)
      .then(res => res.json());
  },

  getStudentProfileById(userid) {
    return fetch
      .get(`${matlsApiUrl}/students/${userid}`)
      .then(res => res.json());
  },

  changeContactStatus(userid, contactid, status) {
    return fetch
      .patch(`${matlsApiUrl}/users/${userid}`, {params: {userid, contactid, status}})
      .then(res => res.json());
  },

  /**
   * Query the teachers according to the conditions.
   * @param {*} params {name, gender, schoolSystemId, subjectId}
   */
  getTeachers(params = {}) {
    return fetch
      .get(`${matlsApiUrl}/teachers`, {params})
      .then(res => res.json());
  },

  updateStudentProfile(params) {
    validator.validate('/user/putstudents4app', params);

    return fetch
      .put(`${matlsApiUrl}/users/putstudents4app`, {params})
      .then(res => res.json());
  }
};